export const getPrimaryObject = ({
	isRelationshipCompany,
	isClient,
	relationshipCompany,
	client,
	deal,
} = {}) => {
	if (isRelationshipCompany) return relationshipCompany;
	if (isClient) return client;
	return deal;
};
